import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Exhibition } from '../types';

interface ExhibitionContextType {
  selectedExhibition: Exhibition | null;
  setSelectedExhibition: (exhibition: Exhibition | null) => void;
}

const ExhibitionContext = createContext<ExhibitionContextType | undefined>(undefined);

export const useExhibitionContext = () => {
  const context = useContext(ExhibitionContext);
  if (context === undefined) {
    throw new Error('useExhibitionContext must be used within an ExhibitionProvider');
  }
  return context;
};

interface ExhibitionProviderProps {
  children: ReactNode;
}

export const ExhibitionProvider: React.FC<ExhibitionProviderProps> = ({ children }) => {
  const [selectedExhibition, setSelectedExhibition] = useState<Exhibition | null>(null);

  const value = {
    selectedExhibition,
    setSelectedExhibition,
  };

  return (
    <ExhibitionContext.Provider value={value}>
      {children}
    </ExhibitionContext.Provider>
  );
};